import selectors from '../../rootSelectors';
import { VOCAB_TQVM_FETCH_RETRY } from '../../common/api/apiRetryGetConstants';
import VocaboServiceClient from '../../common/clients/VocaboServiceClient';
import { playStimulusAudio } from '../../common/stimulus/stimulusButtonActions';
import { fetchContent } from '../vocabActions';
import { GENERAL_AUDIO_DELAY } from '../../constants/time';
import { VOCAB_GRADES_WITH_AUTOPLAY } from '../vocabConstants';

export const fetchVocabTQVMContent = () =>
    fetchContent(VocaboServiceClient.MEASURES.TQVM, VOCAB_TQVM_FETCH_RETRY);

export const autoplayScript = stimulusAudio => (dispatch, getState) => {
    const state = getState();
    const grade = selectors.getGrade(state);

    if (VOCAB_GRADES_WITH_AUTOPLAY.includes(grade)) {
        return dispatch(playStimulusAudio([stimulusAudio], GENERAL_AUDIO_DELAY));
    }

    return Promise.resolve();
};
